// https://stackoverflow.com/a/46181288
function getDocumentElement(): Element {
    return document.scrollingElement || document.documentElement;
}

/**
 * scroll to an element
 * @param el (node) - optional - default to the whole page.
 * @param options (object) - optional
 */
function scrollTo(
    el: Element,
    options: {
        destination?: string;
        duration?: number;
        callback?: () => void;
        offset?: number;
    } = {}
): void {
    const destination = options.destination || 'top';
    const behavior = (t: number): number => t * (2 - t); // easeOutQuad;
    const duration = options.duration || 1000;
    const callback = options.callback;
    const offset = options.offset || 0;

    const documentEl = getDocumentElement();
    const startTime = Date.now();
    const startPos = documentEl.scrollTop;
    let endPos: number;

    if (!el) {
        el = getDocumentElement();
    }
    if (destination === 'bottom') {
        endPos = startPos + el.getBoundingClientRect().bottom - window.innerHeight;
    } else {
        endPos = startPos + el.getBoundingClientRect().top - offset;
    }
    endPos = endPos < 0 ? 0 : endPos;

    function scroll(): void {
        const currentTime = Date.now();
        const timeDiff = currentTime - startTime;
        const time = Math.min(1, timeDiff / duration);

        const posDiff = endPos - startPos;
        const posTimeProd = behavior(time) * posDiff;
        documentEl.scrollTop = startPos + posTimeProd;

        // base case
        if (timeDiff > duration) {
            if (callback) {
                callback();
            }
            return;
        }
        window.requestAnimationFrame(scroll);
    }
    scroll();
}

/**
 * scroll to the top of the page or an element.
 * @param el (node) optional - default to the whole page.
 * @param options (object) optional
 */
export function scrollToTop(
    el: Element,
    options: {
        destination?: string;
        duration?: number;
        callback?: () => void;
        offset?: number;
    } = {}
): void {
    scrollTo(el, {
        ...options,
        destination: 'top',
    });
}
